var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("\n    "+_vm._s(_vm.date)+"\n  ")]),(_vm.appointment.person)?_c('div',[_vm._v("\n    "+_vm._s(_vm.appointment.person.name)+" ("+_vm._s(_vm.appointment.person.phone)+")\n  ")]):_vm._e(),(_vm.appointment.user)?_c('div',[_vm._v("\n    "+_vm._s(_vm.appointment.user.name)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }